import { log } from "next-axiom";

import { GRAPHQL_ENDPOINT } from "@/config";
import { PROMOTIONS_ENABLED } from "@/features/promotions/config";

export type PromotionEventKind = "impression" | "click";
/** Aggregate delivery diagnostics: no credentials, referrer, viewer ID or persistent storage. */
export const sendPromotionEvent = async (
  token: string,
  kind: PromotionEventKind
): Promise<void> => {
  if (
    !PROMOTIONS_ENABLED ||
    !token ||
    navigator.doNotTrack === "1" ||
    (navigator as Navigator & { globalPrivacyControl?: boolean })
      .globalPrivacyControl
  ) {
    return;
  }

  try {
    const response = await fetch(
      new URL("/promotion-events", GRAPHQL_ENDPOINT).href,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, kind }),
        credentials: "omit",
        referrerPolicy: "no-referrer",
        keepalive: true,
        signal: AbortSignal.timeout(5000),
      }
    );

    if (!response.ok) {
      log.warn("promotion-measurement-rejected", {
        status: response.status,
        kind,
      });
    }
  } catch {
    // Never prevent shopping because diagnostics cannot be recorded. No tokens in logs.
    log.warn("promotion-measurement-unavailable", { kind });
  }
};
